<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="h2-1"><span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><b>Contents</b></span></span></p>
<p class="imagec"><img alt="image" height="2" src="images/line.jpg" width="130"/></p>
<div class="top3"><p class="toc_1" id="rint"><a href="#/text/Introduction"><b>Introduction</b></a></p>
<div class="top"><p class="toc_1" id="rpa1"><a href="#/text/Part01"><b>Part I: The Law</b></a></p>
<div class="topa"><p class="toc" id="rch1"><span class="hide">      </span><a href="#/text/Chapter01">The Law and the Constitution</a></p>
<div class="topa"><p class="toc" id="rch2"><span class="hide">      </span><span href="#/text/Chapter02" title="Link target outside of Sample">Lawyers, Judges, and the Practice of Law</span></p>
<div class="topa"><p class="toc" id="rch3"><span class="hide">      </span><span href="#/text/Chapter03" title="Link target outside of Sample">The Supreme Court</span></p>
<div class="topa"><p class="toc" id="rch4"><span class="hide">      </span><span href="#/text/Chapter04" title="Link target outside of Sample">Women and the Law</span></p>
<div class="top"><p class="toc_1" id="rpa2"><span href="#/text/Part02" title="Link target outside of Sample"><b>Part II: Civil Liberties: Free to Be You and Me</b></span></p>
<div class="topa"><p class="toc" id="rch5"><span class="hide">      </span><span href="#/text/Chapter05" title="Link target outside of Sample">American Rights and Values</span></p>
<div class="topa"><p class="toc" id="rch6"><span class="hide">      </span><span href="#/text/Chapter06" title="Link target outside of Sample">Equal Justice under the Law</span></p>
<div class="topa"><p class="toc" id="rch7"><span class="hide">      </span><span href="#/text/Chapter07" title="Link target outside of Sample">The History of the Women’s Rights Movement</span></p>
<div class="topa"><p class="toc" id="rch8"><span class="hide">      </span><span href="#/text/Chapter08" title="Link target outside of Sample">The Rights of Women</span></p>
<div class="topa"><p class="toc" id="rch9"><span class="hide">      </span><span href="#/text/Chapter09" title="Link target outside of Sample">Reproductive Rights</span></p>
<div class="top"><p class="toc_1" id="rpa3"><span href="#/text/Part03" title="Link target outside of Sample"><b>Part III: A Life of Her Own</b></span></p>
<div class="topa"><p class="toc" id="rch10"><span class="hide">      </span><span href="#/text/Chapter10" title="Link target outside of Sample">Memories of a Long Life</span></p>
<div class="topa"><p class="toc" id="rch11"><span class="hide">      </span><span href="#/text/Chapter11" title="Link target outside of Sample">Friends, Family, and Other Influences</span></p>
<div class="topa"><p class="toc" id="rch12"><span class="hide">      </span><span href="#/text/Chapter12" title="Link target outside of Sample">Life Lessons</span></p>
<div class="top"><p class="toc_1" id="rpa4"><span href="#/text/Part04" title="Link target outside of Sample"><b>Milestones</b></span></p>
</div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?48d03036